import { render, staticRenderFns } from "./audiodetail.vue?vue&type=template&id=aa2e135e&"
import script from "./audiodetail.vue?vue&type=script&lang=js&"
export * from "./audiodetail.vue?vue&type=script&lang=js&"
import style0 from "./audiodetail.vue?vue&type=style&index=0&id=aa2e135e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports